<template>
  <span class="avatar" v-if="item.picture && item.picture.path && forcePicto == null">
    <a v-if="removeDataCallback !== null" @click="$emit('remove', removeDataCallback)" class="close"><i class="fal fa-times"></i></a>
    <img :src="item.picture | avatar" class="is-inline-block is-vcentered" >
  </span>
  <span class="avatar" v-else-if="item.pictures && item.pictures.length && forcePicto == null">
    <a v-if="removeDataCallback !== null" @click="$emit('remove', removeDataCallback)" class="close"><i class="fal fa-times"></i></a>
    <img :src="item.pictures[0] | avatar" width="40" :alt="item.pictures[0].name">
  </span>
  <span class="avatar avatar-01" v-else-if="usePicto !== null || forcePicto !== null">
    <a v-if="removeDataCallback !== null" @click="$emit('remove', removeDataCallback)" class="close"><i class="fal fa-times"></i></a>
    <span clss="icon"><i class="is-vcentered" :class="picto"></i></span>
  </span>
  <span v-else class="avatar" :class="'avatar-0' + ((i % 6) + 1)">
    <a v-if="removeDataCallback !== null" @click="$emit('remove', removeDataCallback)" class="close"><i class="fal fa-times"></i></a>
    <span :class="classes">{{initiales | cap}}</span>
  </span>
</template>

<script>
import { isString } from 'lodash'
export default {
  name: 'Avatar',
  props: {
    item: {
      type: [Object, String],
      required: true
    },
    i: { // index to generate avatar color
      type: Number,
      default: 0
    },
    removeDataCallback: {
      type: [String, Array, Object, Number],
      default: null
    },
    classes: {
      type: String
    },
    forcePicto: { // Force l'utilisation du picto même si une image est disponible
      type: [String],
      default: null
    },
    usePicto: { // Utilise le picto si il n'y a pas d'image
      type: [String],
      default: null
    }
  },
  data () {
    return {
      pictos: {contact: 'fas fa-user-crown', utilisateur: 'fas fa-user-tie', societe: 'fas fa-building', promoteur: 'fas fa-kaaba'}
    }
  },
  computed: {
    initiales () {
      let val = ''
      if (this.item.last_name && this.item.first_name) {
        val = this.item.last_name + ' ' + this.item.first_name
      } else if (this.item.name) {
        val = this.item.name[0] + ' ' + this.item.name[1]
      } else if (this.item.seller_name) {
        val = this.item.seller_name
      } else if (this.item.company_name) {
        val = this.item.company_name
      } else if (this.item.origin_name) {
        val = this.item.origin_name
      } else if (isString(this.item)) {
        val = this.item.split(' ')[0][0] + ' ' + this.item.split(' ')[1][0]
      } else {
        return ''
      }

      val = val.split(' ')
      let a = val[0][0]
      let b = (val[1]) ? val[1][0] : val[0][1]
      return a + b
    },
    picto () {
      let type = (this.forcePicto !== null) ? this.forcePicto : this.usePicto
      if (type === null) return
      if (this.pictos[type]) return this.pictos[type]
      else return 'fas fa-question'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/Avatar.vue